import SeparatorWithText from "@/components/SeparatorWithText";
import SortableMenuItemList from "@/components/SortableMenuItemList";
import { Category, MenuItem } from "@/model/entities";
import { FC } from "react";
import { useTranslation } from "react-i18next";

interface MenuItemsViewProps {
  menuItems: MenuItem[];
  categories: Category[];
  onEditMenuItem: (item: MenuItem) => void;
  onDeleteMenuItem: (item: MenuItem) => void;
  onReorderMenuItems: (items: MenuItem[]) => void;
}

const MenuItemsView: FC<MenuItemsViewProps> = ({
  menuItems,
  categories,
  onEditMenuItem,
  onDeleteMenuItem,
  onReorderMenuItems,
}) => {
  const { t } = useTranslation();

  if (menuItems.length === 0) {
    const hasCategories = categories.length > 0;

    return (
      <div className="container mx-auto">
        <div className="flex flex-col items-center justify-center py-16">
          {hasCategories ? (
            <>
              <p className="text-gray-500 text-center text-lg mb-4">
                {t("menuItem.noMenuItems", "עדיין לא הוספו פריטים לתפריט שלך.")}
              </p>
              <p className="text-gray-400 text-center text-sm">
                {t(
                  "menuItem.addItemToStart",
                  "לחץ על כפתור 'הוסף פריט' כדי להתחיל להוסיף פריטים לתפריט."
                )}
              </p>
            </>
          ) : (
            <>
              <p className="text-gray-500 text-center text-lg mb-4">
                {t(
                  "menuItem.noCategoriesMessage",
                  "עדיין לא הוספו קטגוריות לתפריט שלך."
                )}
              </p>
              <p className="text-gray-400 text-center text-sm">
                {t(
                  "menuItem.addCategoryFirstMessage",
                  "עליך להוסיף קטגוריה לפני הוספת פריטים לתפריט."
                )}
              </p>
            </>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="container mx-auto">
      {categories.map((category) => (
        <div key={category.id}>
          <SeparatorWithText text={category.name} />
          <SortableMenuItemList
            items={menuItems.filter((item) => item.categoryId === category.id)}
            onEdit={onEditMenuItem}
            onDelete={onDeleteMenuItem}
            onReorder={onReorderMenuItems}
          />
        </div>
      ))}
    </div>
  );
};

export default MenuItemsView;
